<app-form-page [config]="config" [drillDown]="false" ></app-form-page>
<p style="margin-top: -20px; margin-left: 20px; font-weight: bold">
    Total Debtors Shown: {{totalDebtors | currency}} - 
    Arrears: {{arrears | currency}} - 
    Current Year Charges: {{totalDebtors - arrears | currency}}
</p>
